import { constants, getStorage, sortHandler } from 'helpers'
import { ClientDetailsPayloadInterface } from 'storeTypes'

const { SORT_TYPE, SORT_DIRECTION, CLIENT_SORT_OPTIONS } = constants

const clientsWithOrWithoutPayment =
    (option: boolean) => (client: ClientDetailsPayloadInterface) =>
        !option ? !client.last_voucher_date : client.last_voucher_date

const sortByPaymentDate = (clientData: ClientDetailsPayloadInterface[]) => {
    // get clients with last payment date
    let clientsWithPayment = clientData.filter(
        clientsWithOrWithoutPayment(true)
    )

    // get clients without last payment date
    const clientsWithoutPayment = clientData.filter(
        clientsWithOrWithoutPayment(false)
    )
    clientsWithPayment = sortHandler(
        [...clientsWithPayment],
        'last_voucher_date',
        SORT_TYPE.DATE,
        SORT_DIRECTION.ASCENDING
    )
    return [...clientsWithPayment, ...clientsWithoutPayment]
}

const getPerformanceColorForBalance = (
    balance: number,
    numberOfPayments: number
) => {
    const countryConfig = getStorage('country_config')

    if (!countryConfig?.payment_client_threshold_enabled) {
        return ''
    }

    if (
        numberOfPayments <= 1 ||
        balance <= countryConfig.payment_client_low_threshold
    ) {
        return constants.PERFORMANCE_COLORS.LOW
    }

    if (balance <= countryConfig.payment_client_medium_threshold) {
        return constants.PERFORMANCE_COLORS.MEDIUM
    }

    return constants.PERFORMANCE_COLORS.HIGH
}
const lowClients = (client: ClientDetailsPayloadInterface) =>
    getPerformanceColorForBalance(client.balance, client.smss?.length || 0) ===
    constants.PERFORMANCE_COLORS.LOW

const mediumClients = (client: ClientDetailsPayloadInterface) =>
    getPerformanceColorForBalance(client.balance, client.smss?.length || 0) ===
    constants.PERFORMANCE_COLORS.MEDIUM

const highClients = (client: ClientDetailsPayloadInterface) =>
    getPerformanceColorForBalance(client.balance, client.smss?.length || 0) ===
    constants.PERFORMANCE_COLORS.HIGH

const groupClientWithColorCoding = (
    clients: ClientDetailsPayloadInterface[]
) => {
    const clientsLowThreshold = clients.filter(lowClients)
    const clientsMediumThreshold = clients.filter(mediumClients)
    const clientsHighThreshold = clients.filter(highClients)
    return [
        ...clientsLowThreshold,
        ...clientsMediumThreshold,
        ...clientsHighThreshold
    ]
}

export const processRemainingPayments = (
    clientData: ClientDetailsPayloadInterface[]
) => {
    const countryConfig = getStorage('country_config')

    if (countryConfig?.payment_client_threshold_enabled) {
        if (countryConfig?.client_sort === CLIENT_SORT_OPTIONS.COLOR_CODING) {
            return groupClientWithColorCoding(clientData)
        }
        if (
            countryConfig?.client_sort === CLIENT_SORT_OPTIONS.REMAINING_PAYMENT
        ) {
            return clientData.sort((a, b) => {
                const balanceA = a.all_enrollment - a.balance
                const balanceB = b.all_enrollment - b.balance
                return balanceA - balanceB
            })
        } else {
            return sortByPaymentDate(clientData)
        }
    }
    return sortByPaymentDate(clientData)
}
